module.exports = __webpack_public_path__ + "media/images/courseware_blackboard_courses_icon-8a4b0dd4eca95f5388b4f945c5bc0804.png";